import { render, staticRenderFns } from "./data-subject-privacy-policy.vue?vue&type=template&id=3c09af92"
import script from "./data-subject-privacy-policy.vue?vue&type=script&lang=js"
export * from "./data-subject-privacy-policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports